import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'

import CircleClose from '../images/CircleClose'
import { SecondaryButton, DestructivePrimaryButton } from '../common/Button';

import { showLocalModal, dismissLocalModal } from '../../redux/actions/systemModal';

import './ConfirmDeleteContentModal.css';

export interface ModalContext {
  confirm(content, confirmLabel, cancelLabel?): Promise<boolean>;
}

export const ModalContext = React.createContext({ confirm(content, confirmLabel, cancelLabel) {} });

// TODO: Should streamline use of Modal. This file and SystemModal are two different implementations. Should use one.

interface Props {
  showLocalModal(): void;
  dismissLocalModal(): void;
}

interface State {
  visible: boolean;
  resolve(r: boolean): void;
  content: React.ReactFragment;
  confirmLabel: string;
  cancelLabel: string;
}


class ModalContainerTemplate extends React.Component<Props, State> implements ModalContext {
  state = {
    visible: false,
    resolve: (r) => {},
    content: null,
    confirmLabel: null,
    cancelLabel: null,
  };

  render() {
    const { children } = this.props;
    const { visible, resolve, content, confirmLabel, cancelLabel } = this.state;

    return (
      <ModalContext.Provider value={this}>
        {
          visible &&
          <div className="cmp-modal">
            <div className="cmp-modal-background" onClick={() => resolve(false)}/>

            <div className="cmp-modal-content">
              <div style={{ position: 'absolute', right: 20, top: 12, cursor: 'pointer' }} onClick={() => resolve(false)}>
                <CircleClose primaryColor="rgb(17,17,17)" secondaryColor="white" size={52}/>
              </div>

              <div style={{ marginTop: 50 }}>
                {content}
              </div>

              <div style={{ display: 'flex', marginTop: 72 }}>
                <DestructivePrimaryButton
                  onClick={() => resolve(true)}
                  style={{ marginRight: 24, flexGrow: 1 }}
                >
                  <FormattedMessage id={confirmLabel}/>
                </DestructivePrimaryButton>

                <SecondaryButton onClick={() => resolve(false)} style={{ flexGrow: 1 }}>
                  <FormattedMessage id={cancelLabel}/>
                </SecondaryButton>
              </div>
            </div>
          </div>
        }

        {children}
      </ModalContext.Provider>
    );
  }

  confirm = (content, confirmLabel, cancelLabel = 'nav.cancel.button.label') => {
    return new Promise<boolean>((r) => {
      const resolve = (val) => {
        this.setState({ visible: false });
        this.props.dismissLocalModal();
        r(val);
      };

      this.setState({ resolve, content, confirmLabel, cancelLabel, visible: true })
      this.props.showLocalModal();
    });
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showLocalModal: () => {
      dispatch(showLocalModal());
    },
    dismissLocalModal: () => {
      dispatch(dismissLocalModal());
    },
  };
}

export const ModalContainer = withRouter(connect(() => ({}), mapDispatchToProps)(ModalContainerTemplate));
